var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.373,
    height: 18.66,
    viewBox: "0 0 17.373 18.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#c4cdd4;}.b{fill:#587386;stroke-width:0.5px;}.b,.c{stroke:#587386;}.c{stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.321 -388.223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.953,0A3.953,3.953,0,1,1,0,3.953,3.953,3.953,0,0,1,3.953,0Z",
    transform: "translate(27.613 389.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.336,8.716a4.358,4.358,0,1,1,4.336-4.38A4.349,4.349,0,0,1,13.336,8.716Zm0-7.849a3.469,3.469,0,1,0,3.469,3.469A3.479,3.479,0,0,0,13.336.867Z",
    transform: "translate(17.68 388.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.332,26.44H3.058a2.521,2.521,0,0,1-1.127-.281A2.094,2.094,0,0,1,.8,23.769a7.771,7.771,0,0,1,3.079-4.323,2.013,2.013,0,0,1,2.038-.141,6.215,6.215,0,0,0,5.464,0,2.014,2.014,0,0,1,1.995.105,8.006,8.006,0,0,1,3.079,4.358,2.139,2.139,0,0,1-1.3,2.5A1.969,1.969,0,0,1,14.332,26.44Z",
    transform: "translate(22.367 379.692)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilledIcon);
export default __webpack_public_path__ + "static/media/person_filled_icon.6cb4adbf2d9926bb47ac79d1f41e9dd9.svg";
export { ForwardRef as ReactComponent };